import React, { useMemo, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { EnumModuloDesc, EnumPathRutas, EnumTablaPaginacion } from '../../../Utils/Enumeradores/ComunEnum';
import ConservacionTable from '../Components/TablaConservacion';
import ModalSolicitudDescarga from '../Components/ModalSolicitudDescarga';
import { useComun } from '../../../Hooks/useComun';
import Card from "../../../Components/Card/Card";
import { ObtenerInformeConservacion } from '../Services/ObtenerInformeConservacion';
import { useColumnsInforme } from '../Utils/ColumnsInformeConservacion';

const InformesConservacion = () => {
	const { downloadCSV } = useComun();
	const [datosBusqueda, setDatosBusqueda] = React.useState({ fechaInicio: moment().subtract(1, 'M').format(), fechaTermino: moment().format() });
	const [show, setShow] = React.useState(false);
	const [pageCount, setPageCount] = useState(0);
	const [data, setData] = useState([]);
	const handleClose = () => setShow(false);
	const [datosModal, setDatosModal] = React.useState({});
	const { COLUMNS } = useColumnsInforme();
	const columns = useMemo(() => COLUMNS, []);
	const [{ pageIndex, pageSize, sortBy }, setPagination] = useState({
		pageIndex: 0,
		pageSize: EnumTablaPaginacion.CantidadPaginacion,
		sortBy: []
	});

	const postBuscarInformeConservacion = async (values) => {
		const resp = await ObtenerInformeConservacion(values);
		if (resp) {
			if (resp.status === 200) {
				if (values.datosBuscar.exportacion) {
					downloadCSV(resp.data, "Informe conservación", EnumModuloDesc.DescargarInformeConservacion);
				} else {
					setPageCount(resp.data.cantidadPaginas);
					setData(resp.data.listObtenerInformeConservacion);
				}
			} else if (resp.status === 206) {
				setPageCount(0);
				setData([]);
			}
		}
	};

	const fetchData = useCallback(({ formulario, pageIndex, sortBy = [], exportacion = false }) => {
		formulario.paginacion.numeroPagina = pageIndex + 1;
		formulario.paginacion.ordenadoPor = sortBy.length > 0 ? sortBy[0].id : formulario.paginacion.ordenadoPor;
		formulario.paginacion.orderByAscending = sortBy.length > 0 ? !sortBy[0].desc : formulario.paginacion.orderByAscending;
		formulario.datosBuscar.exportacion = exportacion;
		postBuscarInformeConservacion(formulario);
	}, []);

	return (
		<div className="container-fluid">
			<div className="row mb-4">
				<div className="col-12">
					<div className="breadcrumbs">
						<ul>
							<li><Link to={EnumPathRutas.Inicio}> Inicio</Link></li>
							<li><Link to={EnumPathRutas.Informes}>Informes</Link></li>
							<li><a href="#">Informes de Conservación</a></li>
						</ul>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<div className="bg-white rounded p-4">
						<div className="row">
							<div className="col-12">
								<Card className="p-4">
									<ConservacionTable
										columns={columns}
										data={data}
										fetchData={fetchData}
										pageCount={pageCount}
										currentpage={pageIndex}
										pageSize={pageSize}
										sortBy={sortBy}
										setPagination={setPagination}
									/>
								</Card>
							</div>
						</div>

					</div>
				</div>
			</div>
			<ModalSolicitudDescarga
				show={show}
				datosModal={datosModal}
				datosBusqueda={datosBusqueda}
				onHide={handleClose}
			/>
		</div>
	)
}

export default InformesConservacion;
